export const STRIPE_PUBLIC_KEY =
  "pk_live_51O4eAaJ1Erqf01gGDCtXKlS9C4t9uRRXt1FRII1Gk2TViz1l3Khmcj1xBZXsNgg2yNPESHxCYJ2jij9Zb15q4z4i002jfatMD7";

export const PRICE_ID_LIST = [
  "price_1O7A0KJ1Erqf01gGA5XyNcmr", //init product
];
